import * as actionTypes from "../actions/actionTypes";
import { without } from "lodash";

export default function recoveredAssets(state = {}, action) {
  switch (action.type) {
    case actionTypes.FETCH_KIT_RECOVERED_ASSETS_SUCCESS:
      return {
        ...state,
        [action.uuid]: [
          ...((action.page !== 1 && state[action.uuid]) || []),
          ...action.response.result.items,
        ],
      };

    case actionTypes.MOVE_ITEMS_SUCCESS: {
      //Remove moved items from recovered assets state
      const itemUuids = action.itemUuids.map(i => i.concat("-0"));
      const firstItemUuid = itemUuids[0];
      const kitId = action.response.entities.items[firstItemUuid].kitId;
      return { ...state, [kitId]: without(state[kitId], ...itemUuids) };
    }

    default:
      return state;
  }
}
